import { render } from "./UploadedFileDisplay.vue?vue&type=template&id=d336af72&scoped=true"
import script from "./UploadedFileDisplay.vue?vue&type=script&lang=js"
export * from "./UploadedFileDisplay.vue?vue&type=script&lang=js"

import "./UploadedFileDisplay.vue?vue&type=style&index=0&id=d336af72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d336af72"]])

export default __exports__